import config from '@website/config';
import { UserBookingDetailsQuery } from '@website/types/graphqlOperations';
import { DateTime } from 'luxon';
import countries from '@website/dataObjects/countries';

type Props = {
  meetPoint: UserBookingDetailsQuery['booking']['spaces'][0]['guest']['tripForm']['meetPoint'];
  start: UserBookingDetailsQuery['booking']['group']['start'];
};

export default function MeetPoint({ meetPoint, start }: Props) {
  const groupStart = DateTime.fromISO(start.utc, {
    zone: start.zone,
  });

  const meetPointTime = DateTime.fromISO(meetPoint.arriveAt.localTime);

  const lines = [
    meetPoint.address.addressLine1,
    meetPoint.address.addressLine2,
    meetPoint.address.locality,
    meetPoint.address.dependentLocality,
    meetPoint.address.administrativeArea,
    meetPoint.address.postalCode,
    meetPoint.address.country ? countries[meetPoint.address.country] : '',
  ];

  const encodedAddress = encodeURIComponent(
    lines.filter((i) => i && i !== '').join(', '),
  );

  const query = meetPoint.address.coordinates.lat
    ? `${meetPoint.address.coordinates.lat},${meetPoint.address.coordinates.lng}`
    : encodedAddress;

  const center = encodeURIComponent(
    `${meetPoint.address.coordinates.lat},${meetPoint.address.coordinates.lng}`,
  );

  return (
    <div className="text-block">
      <h5>Meet point</h5>
      <h6 className="text-muted">
        {meetPoint.address.addressLine1} at{' '}
        {meetPointTime.toLocaleString(DateTime.TIME_SIMPLE)} on{' '}
        {groupStart.toLocaleString(DateTime.DATE_MED_WITH_WEEKDAY)}
      </h6>
      <div className="video_wrapper mb-3">
        <iframe
          width="100%"
          style={{
            border: 0,
            aspectRatio: '16 / 9',
          }}
          loading="lazy"
          allowFullScreen
          referrerPolicy="no-referrer-when-downgrade"
          src={`https://www.google.com/maps/embed/v1/place?key=${config.Google.placesApiKey}&q=${query}&center=${center}`}
        ></iframe>
      </div>
    </div>
  );
}
